import axios from 'axios';
import { SupplierModel } from '../models/SupplierModel';

const API_URL = process.env.REACT_APP_API_URL;
const SUPPLIERS_URL = `${API_URL}/api/b2b/suppliers/`;

export function listSuppliers(
  state?: string
): Promise<{ data: Array<SupplierModel> }> {
  return axios.get(`${SUPPLIERS_URL}`);
}

export function retrieveSupplier(id: number): Promise<{ data: SupplierModel }> {
  return axios.get(`${SUPPLIERS_URL}${id}/`);
}

export function createSupplier(
  supplier: SupplierModel
): Promise<{ data: SupplierModel }> {
  return axios.post(SUPPLIERS_URL, supplier);
}

export function updateSupplier(
  supplier: Partial<SupplierModel> & { id: number }
): Promise<{ data: SupplierModel }> {
  let supplierPayload = { ...supplier };

  Object.keys(supplierPayload).forEach(
    (key) => supplierPayload[key] === null && delete supplierPayload[key]
  );
  return axios.patch(`${SUPPLIERS_URL}${supplier.id}/`, supplierPayload);
}
